import { DexActivityTabEntry } from '@mark43/cad-api';
import { Virtuoso } from 'react-virtuoso';
import { DexActivityEntry } from './dex-activity-entry';

export function DexActivityTabVirtuosoEntriesList({ entries }: { entries: DexActivityTabEntry[] }) {
    const computeItemKey = (index: number) => entries[index].elasticUserActionId;
    const renderItemContent = (index: number) => {
        const entry = entries[index];

        return <DexActivityEntry entry={entry} />;
    };

    return (
        <Virtuoso
            totalCount={entries.length}
            data={entries}
            computeItemKey={computeItemKey}
            itemContent={renderItemContent}
            overscan={200}
            style={{
                height: '100%',
                width: '100%',
            }}
        />
    );
}
